import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { OrderType } from '@/api/model'
import { useGetApiCompaniesCurrentAuditlogs } from '@/api/generated/company-management-user/company-management-user'
import { PageLayout } from '@/components/layout/PageLayout'
import { TableCard } from '@/components/common/table/TableCard'
import { PaginationFooter } from '@/components/common/table/PaginationFooter'
import { AuditLogsDataTable } from './AuditLogsDataTable'
import { PageHeader } from '@/components/layout/PageHeader'

const DEFAULT_PAGE_SIZE = 10

export default function AuditLogsPage() {
  const { t } = useTranslation('audit-logs')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [sort, setSort] = useState<string | undefined>(undefined)
  const [order, setOrder] = useState<OrderType | undefined>(undefined)

  const { data, isLoading, isError} = useGetApiCompaniesCurrentAuditlogs({
    Offset: (page - 1) * pageSize,
    Limit: pageSize,
    Sort: sort,
    Order: order,
  })

  const items = (data?.data?.items ?? []) as any[]
  const totalCount = data?.data?.totalCount ?? 0

  const handleSort = useCallback((newSort?: string, newOrder?: OrderType) => {
    setSort(newSort)
    setOrder(newOrder)
    setPage(1)
  }, [])

  return (
    <PageLayout>
      <PageHeader
        title={t('header.title')}
        description={t('header.description')}
      />

      <TableCard>
        <div className="flex-1 overflow-auto scrollbar-custom relative">
          <AuditLogsDataTable
            isLoading={isLoading}
            isError={isError}
            items={items}
            currentSort={sort}
            currentOrder={order}
            onSort={handleSort}
          />
        </div>

        <PaginationFooter
          offset={(page - 1) * pageSize}
          limit={pageSize}
          totalCount={totalCount}
          onOffsetChange={(offset) => setPage(Math.floor(offset / pageSize) + 1)}
          onPageSizeChange={(size) => { setPageSize(size); setPage(1) }}
        />
      </TableCard>
    </PageLayout>
  )
}
